import { Badge } from "react-bootstrap";

export function BreakpointDebugger() {
        return (
            <Badge>
                <span className="d-inline  d-sm-none">xs</span>
                <span className="d-none d-sm-inline  d-md-none">sm</span>
                <span className="d-none d-md-inline  d-lg-none">md</span>
                <span className="d-none d-lg-inline  d-xl-none">lg</span>
                <span className="d-none d-xl-inline  d-xxl-none">xl</span>
                <span className="d-none d-xxl-inline ">xxl</span>
            </Badge>
        );
    }
